import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Base } from './Base.js';
import * as utils from './utils.js';
export var Reserved = /*#__PURE__*/function (_Base) {
  _inherits(Reserved, _Base);
  var _super = _createSuper(Reserved);
  function Reserved(type) {
    var _this;
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    _classCallCheck(this, Reserved);
    _this = _super.call(this);
    _this.type = type;
    _this.count = count;
    return _this;
  }
  _createClass(Reserved, [{
    key: "decode",
    value: function decode(stream, parent) {
      stream.pos += this.size(null, parent);
      return undefined;
    }
  }, {
    key: "size",
    value: function size(data, parent) {
      var count = utils.resolveLength(this.count, null, parent);
      return this.type.size() * count;
    }
  }, {
    key: "encode",
    value: function encode(stream, val, parent) {
      return stream.fill(0, this.size(val, parent));
    }
  }]);
  return Reserved;
}(Base);